/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InstallationType {
    USER = 'User',
    ORGANIZATION = 'Organization'
}

export function InstallationTypeFromJSON(json: any): InstallationType {
    return InstallationTypeFromJSONTyped(json, false);
}

export function InstallationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallationType {
    return json as InstallationType;
}

export function InstallationTypeToJSON(value?: InstallationType | null): any {
    return value as any;
}

